<template>
  <div class="node-certificate common-certificate">
    <action-bar>
      <btn-style :btn-list="btnList"></btn-style>
    </action-bar>
    <normal-table
      ref="commonTable"
      :table-col="tableCol"
      :table-data="nodeList"
      :first-table-col="firstTableCol"
      :operator="operator"
      :operate-col="operateCol"
      :show-edit="true"
      :paging="nodePaging"
      @pagination="handleSizeOrPageChange"
    >
      <template slot="status" slot-scope="{ param }">
        <span
          class="cert-status"
          :class="param.row.Status === 'normal' ? 'is-normal' : 'is-cancel'"
          >{{ formatStatus(param.row.Status) || $constants.EMPTY }}</span
        >
      </template>
    </normal-table>
    <init-node ref="initNode" @update:list="getList()"></init-node>
    <see-dialog ref="seeDialog"></see-dialog>
    <import-node ref="importNode" @update:list="getList()"></import-node>
    <gen-node ref="genNode" @update:list="getList()"></gen-node>
  </div>
</template>

<script>
import auth from '@/auth/index'
import { mapState, mapActions } from 'vuex'
import initNode from './components/initNode'
import seeDialog from './components/seeDialog'
import importNode from './components/importNode'
import genNode from './components/genNode'
export default {
  name: 'Node',
  components: {
    initNode,
    seeDialog,
    importNode,
    genNode
  },
  data() {
    return {
      btnList: [
        {
          btnContent: '生成节点证书',
          click: () => {
            return this.genNode()
          },
          icon: 'icon-gen',
          auth: auth.certificate.certAuth.nodeCert.createNodeCert
        },
        {
          btnContent: '导入节点证书',
          click: () => {
            return this.importNode()
          },
          icon: 'icon-import',
          auth: auth.certificate.certAuth.nodeCert.importNodeCert
        },
        {
          btnContent: '申请节点证书',
          click: () => {
            return this.initNode()
          },
          icon: 'icon-apply',
          auth: auth.certificate.certAuth.nodeCert.requireNodeCert
        }
      ],
      // 设置table的列
      tableCol: [
        {
          prop: 'OrgId',
          label: '组织ID',
          minWidth: 133
        },
        {
          prop: 'NodeName',
          label: '节点名称',
          minWidth: 98
        },
        {
          prop: 'AuthType',
          label: '认证模式',
          formatter: row => {
            return this.algoToAuthType(row.Algorithm)
          },
          minWidth: 105
        },
        {
          prop: 'Algorithm',
          label: '密码算法',
          formatter: row => {
            return this.formatAlgo(row.Algorithm)
          },
          minWidth: 94
        },
        {
          prop: 'CertUse',
          label: '证书用途',
          formatter: row => {
            return this.formatUsage(row.CertUse)
          },
          minWidth: 80
        },
        {
          prop: 'OrgName',
          label: '所属组织',
          minWidth: 102
        },
        {
          prop: 'CertType',
          label: '节点角色',
          formatter: row => {
            return this.formatRole(row.CertType)
          },
          minWidth: 70
        },
        {
          prop: 'Status',
          label: '状态',
          minWidth: 126,
          slotName: 'status',
          align: 'center',
          headerAlign: 'center',
        },
        {
          prop: 'createAt',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row)
          },
          minWidth: 151
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '查看公钥',
          showText: true,
          click: (row, col, cellValue) => {
            return this.getInfo(row)
          },
          icon: 'icon-check'
        },
        {
          text: '下载',
          showText: true,
          click: (row, col, cellValue) => {
            return this.downloadFile(row)
          },
          icon: 'icon-download'
        },
        {
          text: '撤销',
          showText: true,
          click: (row, col, cellValue) => {
            return this.delInfo(row)
          },
          icon: 'icon-cancel',
          formatter: row => {
            return this.judgeShow(row)
          }
        }
      ],
      operateCol: {
        minWidth: 208
      },
      firstTableCol: {
        select: false,
        type: 'selection'
      }
    }
  },
  computed: {
    ...mapState({
      nodeList: state => state.certificate.node_list,
      nodePaging: state => state.certificate.node_paging
    })
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['getNodeLists']),
    getList(limit = 10, offset = 0, name) {
      let params = {
        offset,
        limit,
        certType: 1,
        name,
        chainMode: 'permissionedWithCert' //普通认证
      }
      this.getNodeLists(params)
    },

    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row.createAt)
    },
    algoToAuthType(algo) {
      switch (algo) {
        case 2:
          return 'withIBC'
        default:
          return 'withCert'
      }
    },
    formatAlgo(algo) {
      if (algo === 0) {
        return '国密'
      } else if (algo === 1) {
        return 'ECDSA'
      } else if (algo === 2) {
        return 'SM9'
      }
      return '未知算法:' + algo
    },
    formatUsage(usage) {
      switch (usage) {
        case 0:
          return '签名'
        case 1:
          return '通信'
        case 2:
          return 'PEM'
        case 3:
          return 'IBC签名'
        case 4:
          return 'IBC通信'
        default:
          return '未知用途:' + usage
      }
    },
    formatRole(role) {
      let type = ['组织证书', '管理员用户', '普通用户', '共识节点', '普通节点', '轻节点', '根证书']
      return type[role - 1]
    },
    formatStatus(status) {
      return status === 'normal' ? '正常' : '已撤销'
    },
    initNode() {
      this.$refs.initNode.handleOpen()
    },
    importNode() {
      this.$refs.importNode.handleOpen()
    },
    getInfo(row) {
      let data = {
        cert: row.Cert,
        title: row.NodeName,
        type: 'Cert'
      }
      this.$refs.seeDialog.handleOpen(data)
    },
    downloadFile(row) {
      const name = row.NodeName + '.key'
      this.$utils.createFileAndDownload(name, row.Cert)
    },
    // 判断撤销按钮显示与隐藏
    judgeShow(row) {
      return row.Source === 'ca_service' && row.Status === 'normal'
    },
    delInfo(row) {
      this.$prompt('请输入节点证书撤销理由', '撤销证书', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.+$/,
        inputErrorMessage: '请输入撤销原因'
      })
        .then(({ value }) => {
          let param = {
            certId: row.id,
            reason: value
          }
          this.$apis.certificate.revokeCert(param).then(res => {
            this.$message({
              type: 'success',
              message: `节点证书撤销成功！`
            })
          })
          this.refresh()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消撤销'
          })
        })
    },
    refresh() {
      const { offset, limit } = this.nodePaging
      this.getList(limit, offset)
    },
    genNode() {
      this.$refs.genNode.handleOpen()
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.node-certificate.common-certificate {
  .normal-table-wrap {
    height: 100%;
    min-height: var(--common-certificate-list-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--common-certificate-list-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--common-certificate-list-min-height);

        .cert-status {
          padding: var(--common-certificate-list-status-padding);
          display: inline-block;
          &.is-normal {
            color: var(--base-color-success);
          }

          &.is-cancel {
            color: var(--base-color-danger);
            background-color: rgba(233, 87, 87, 0.34);
          }
        }
      }
    }
  }
}
</style>
